import { PayGroupsPanel } from '../components/PayGroupsPanel';
import type { OrgData } from '../organisationFixtures';

interface PayrollTabProps {
  orgId: string;
  orgData: OrgData;
}

export const PayrollTab = ({ orgData }: PayrollTabProps) => (
  <PayGroupsPanel businessRecords={orgData.businessRecords} />
);
